<template>
  <div class="d-flex flex-column flex-center text-center py-8 text-dark-50 user-select-none">
    <img
      src="media/svg/icons/Files/Folder-minus.svg"
      class="w-40px mb-4 opacity-40" />
    <div class="font-size-lg opacity-60">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'NoDataFound',
  props: {
    text: {
      type: String,
      required: false,
      default: () => 'No Data Found',
    },
  },
}
</script>
